const baseUrl = 'https://ikigai-api.herokuapp.com/api/v1';

const utils = {
  baseUrl
}

export default utils
